import { WebSocketConfig } from "@/types/websocket";
import { logger } from "@/utils/logger";

const isProduction = process.env.NODE_ENV === "production";
const backendHost = isProduction ? "licitarsv1.robovisorusa.com" : "localhost";
const port = isProduction ? "" : ":8000";

export const websocketConfig: WebSocketConfig = {
  baseUrl: isProduction ? `wss://${backendHost}` : `ws://${backendHost}${port}`,
  path: "/ws/chat/",
  healthCheckEndpoint: "/api/chat/health/",
  connectionTimeout: 30000,
  maxReconnectAttempts: 5,
  reconnectInterval: 1000,
  maxReconnectInterval: 30000,
  heartbeatInterval: 20000,
  pingTimeout: 5000,
  rateLimit: {
    maxRequests: 100,
    timeWindow: 60000,
    cooldownPeriod: 5000,
  },
  messageQueue: {
    maxSize: 100,
    retryInterval: 1000,
    maxRetries: 3,
  },
  session: {
    maxConnections: 5,
    maxIdleTime: 3600000,
    cleanupInterval: 300000,
  },
};

export const getWebSocketUrl = (token: string, sessionId: string): string => {
  if (!sessionId) {
    throw new Error("Session ID is required for WebSocket connection");
  }
  if (!token) {
    throw new Error("Token is required for WebSocket connection");
  }

  const url = new URL(
    `${websocketConfig.baseUrl}${websocketConfig.path}${sessionId}/`,
  );
  url.searchParams.append("token", token);
  return url.toString();
};

export const getHealthCheckUrl = (): string => {
  return `${websocketConfig.baseUrl}${websocketConfig.healthCheckEndpoint}`;
};

export const checkServerAvailability = async (): Promise<boolean> => {
  try {
    const response = await fetch(getHealthCheckUrl());
    return response.ok;
  } catch (error) {
    logger.error("[WebSocketConfig] Server health check failed:", error);
    return false;
  }
};

// WebSocket endpoints
export const WS_ENDPOINTS = {
  CHAT: (sessionId: string) => {
    if (!sessionId) {
      logger.error("[WS_ENDPOINTS] Session ID is required for chat connection");
      throw new Error("Session ID is required for chat connection");
    }
    return `${websocketConfig.baseUrl}${websocketConfig.path}${sessionId}/`;
  },
};
